'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var build = {exports: {}};

exports.build = build;
